import { Typography, Stack, Grid } from "@mui/material";
import {  TechnologyInterface } from "./KnownTechSection.helpers";
import useIsMobile from "../AppHelpers";

export interface KnownTechPanelProps {
    technology: TechnologyInterface[]
    title: string
}

const KnownTechPanel = ({technology, title}:KnownTechPanelProps)=> {
  const isMobile = useIsMobile()
  
  const PATH_TO_IMG = './img/'
  const IMG_TAG = '.png'

    const getSrc = (logo: string): string=>{
        return PATH_TO_IMG + logo + IMG_TAG
    }
 const getAllowedWidth =()=>{
        return isMobile ? '20vw':'65vw'
    }
    return (
                 <Stack width={getAllowedWidth}>
                    <Typography variant='h5' textAlign={'left'} color='primary'>{title}</Typography>
                    <Grid container textAlign={'center'} height={'55vh'} sx={{overflowY: 'auto'}}>
                      {technology?.map((tech)=>{
                        return (
                        <Grid key={tech.name} size={{xs:12, sm:2, md:3}}>
                          <Stack direction={'row'}>
                            <Stack direction={'column'} sx={{alignItems: 'center'}}>
                                 {!isMobile && <img
                                      srcSet={getSrc(tech.logo)}
                                      src={getSrc(tech.logo)}
                                      alt={tech.logo +' logo'}
                                      width={'175rem'}
                                      height={'130rem'}
                                  />}
                                  <Typography variant="body1" color="primary.main">{tech.name}</Typography>
                              </Stack>
                            </Stack>
                          </Grid>)
                      })}
                    </Grid>
                </Stack>
    );
  }
  
  export default KnownTechPanel;